import { Button } from '@calizahq/react-components-v2'
import { Form, Formik } from 'formik'
import React, { FC } from 'react'

import { InputFile } from '@/components'
import { TicketMutations } from '@/graphql/mutations/ticket.mutations'
import { useMobile } from '@/hooks'
import { useGraphqlMutation } from '@/hooks/useGraphql'

type FormSchema = { attachments?: File[] }
type Props = {
  refetchOnSuccess?: () => void
  ticketId: number
}
const intialValues: FormSchema = { attachments: [] }

export const CreateAttachment: FC<Props> = ({ ticketId, refetchOnSuccess }) => {
  const { isMobile } = useMobile()
  const { mutate, isPending: isMutationLoading } = useGraphqlMutation(TicketMutations.createTicketAttachments(), {
    onSuccess: () => {
      refetchOnSuccess && refetchOnSuccess()
    },
  })
  const handleSubmit = ({ attachments }: FormSchema) => {
    mutate({
      recordType: 'Ticket',
      recordId: ticketId,
      attachments,
    })
  }
  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        ...intialValues,
      }}
      onSubmit={(values, { resetForm }) => {
        handleSubmit(values)
        resetForm({ values: { ...intialValues } })
      }}
      validateOnBlur={false}
    >
      {() => {
        return (
          <Form className="flex w-full flex-col flex-wrap rounded-lg border-t pt-4 border-secondary">
            <InputFile
              accept={{
                'image/jpeg': [],
                'image/png': [],
                'application/pdf': [],
              }}
              className="mb-4"
              gridClassName="grid-cols-3 md:grid-cols-6"
              id="attachments"
              isPreview={!isMobile}
              label="Upload files"
              maxFiles={6}
              maxSize={15000000}
              name="attachments"
            />
            <div className="flex  justify-end md:flex-row">
              <Button
                className="mb-2 w-full bg-text-semantic-success md:mb-0 md:w-auto"
                disabled={isMutationLoading}
                isLoading={isMutationLoading}
                size={'small'}
                type="submit"
              >
                Upload
              </Button>
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}
